exports.__esModule = true;
exports.default = require('./lib/reduxMiddleware').default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-block-ui/reduxMiddleware.js
// module id = 1567
// module chunks = 10